// src/pages/about.js

import React from "react"

import { graphql } from "gatsby"
import Layout from "../components/layout"

export default ( {data} ) => (
  <Layout> 
    <h1 className="page-title">This {data.site.siteMetadata.pagetitle}</h1>  
    <p>Content for about page. A react way!</p>
    <img src="https://source.unsplash.com/600x300/?cat" alt="" />
  </Layout>
)
// page query
export const query = graphql`  
  query {    
      site {      
         siteMetadata {        
              pagetitle      
        }    
      }  
   }`